import _ from 'underscore'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import $appConfig from 'servicestack/config'
import templateUrl from 'emun.vendor/vendorgroup-dashboard.htm'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import vendorConfig from 'emun.vendor/vendor.config'
import ServiceBus from 'servicestack/service-bus'
import prompt from 'emun.vendor/vendorgroup-edit'

export default class VendorGroupDashboardController {
	constructor(createAutoQuery, $session, $window, $state) {
		basicController(this)
		var map = this;
		let $ctrl = this;
		$ctrl.bus = new ServiceBus();
		$ctrl.vendorConfig = vendorConfig;
		$ctrl.chartLoaded = false;
		$ctrl.productImage = $appConfig.productImage.bind($appConfig);
		let options = {
			url: 'QueryRepGroups.json?Id=' + $ctrl.groupId,
			pageSize: 15,
			orderBy: 'Name',
			autoLoad: true,
			append: false,
			onLoaded: function (args) {
				$ctrl.vendorGroup = args.first;
				$ctrl.$state.current.customTitle = $ctrl.vendorGroup.name;
				$ctrl.submissionId = $ctrl.vendorGroup.tags.EditForm;
				if ($ctrl.submissionId) {
					$ctrl.bus
						.send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
						.then(({ data }) => {
							if (data.results.length) {
								$ctrl.submission = {
									label: "vendorgroup-edit",
									data: data.results[0].data
								};
								$ctrl.vendorGroup.meta = Object.assign(
									{},
									$ctrl.vendorGroup.meta,
									data.results[0].data
								);
							}
						});
				}
			}
		};
		$ctrl.query = createAutoQuery(options);
		$ctrl.$on('$vendorgroupEditSubmitted', () => $ctrl.query.load(true));
	}
	load() { return $ctrl.query.load.apply($ctrl.query, arguments); }
	edit() {
		const $ctrl = this;
		return prompt.open({
			title:
			$ctrl.vendorGroup.id +
			" - " +
			$ctrl.vendorGroup.name +
			" Edit...",
			vendor: $ctrl.vendorGroup
		}).then(function () {
			$ctrl.query.load(true);
		});
	}
}
